import { gql } from "@apollo/client";

export const GET_MILESTONES = gql`
  query MilestoneInfo($domain: String!, $input: BasicQueryInfoInput!) {
    milestone {
      info(domain: $domain, input: $input) {
        name
        milestone_id
        deleted
      }
    }
  }
`

export type MilestoneInfo = {
  milestone_id: number;
  name: string;
  deleted: boolean;
};
 
export interface MilestonesResponse {
  milestone: {
    info: MilestoneInfo[]
  }
}
